import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAxios
  from '../../axios/useAxios';
import PageLoader from '../../components/loader/PageLoader';
import HeaderCart from '../../components/HeaderCart';
import { Link, useNavigate } from 'react-router-dom';
import BackButton from '../../components/button/BackButton';
import { ACCOUNT, HOME } from '../../constants/routes';
import { formatPriceWithEuro } from '../../utils/StringUtils';
import { notifyError } from '../../utils/Notify';
import { isAppPWA } from '../../utils/helper-functions';
import { FooterAccount } from '../../components/footerAccount';

const TicketScreen = () => {
  function formatTime(dateTime) {
    const date = new Date(dateTime);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}h${formattedMinutes}`;
  }

  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const stores = useSelector((state) => state.store);
  const [visibleTickets, setVisibleTickets] = useState([]);
  const [visibleProducts, setVisibleProducts] = useState([]);
  const [receipts, setReceipts] = useState();
  const [receiptsLoading, setReceiptsLoading] = useState(true);

  const { store } = stores;
  const storelogo = store ? store.logo : '';

  const ticketLength = (order) => {
    return order.map((product) => product.Qty).reduce((a, b) => a + b);
  };

  useEffect(() => {
    const fetchReceipts = async () => {
      window.scrollTo(0, 0);

      if (!user?._id) {
        notifyError('Erreur', 'Tu dois être connecté');
        navigate(ACCOUNT);
        return;
      }

      try {
        const { data } = await axiosInstance.get(`/user/receipt/${user._id}`);
        setReceipts(data);
        setReceiptsLoading(false);
      } catch (e) {
        notifyError('Erreur', 'Chargement des tickets échoué');
        navigate(ACCOUNT);
        console.error('Error in fetchReceipts', e);
      }
    };

    fetchReceipts();
  }, [user._id, navigate]);

  const isPWA = isAppPWA();
  const toggleContentVisibility = (index, item) => {
    console.log('====> item', item);
    const newVisibleTickets = [...visibleTickets];
    newVisibleTickets[index] = !newVisibleTickets[index];
    setVisibleTickets(newVisibleTickets);
  };
  const toggleContentProductVisibility = (index) => {
    const newVisibleProducts = [...visibleProducts];
    newVisibleProducts[index] = !newVisibleProducts[index];
    setVisibleProducts(newVisibleProducts);
  };
  const [selectedItem, setSelectedItem] = useState(0);

  return (
    <>
      {receiptsLoading || !receipts ? (
        <PageLoader />
      ) : (
        <div className={'ticket-screen bg-gradient1' + (isPWA ? ' pwa' : '')}>
          <FooterAccount
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
          />
          <div className="global-header">
            {!isPWA && <BackButton onClick={() => navigate(ACCOUNT)} />}
            <HeaderCart titre="Mes tickets" transparent={true} />
          </div>
          {!receipts || receipts.length < 1 ? (
            <div className="no-ticket">
              <h1>Pas de ticket</h1>
              <Link className="cart-empty " to={ACCOUNT}>
                {'<'} Retour à l'accueil
              </Link>
            </div>
          ) : (
            <>
              {receipts &&
                receipts.length > 0 &&
                receipts
                  .sort((a, b) => new Date(b.paidAt) - new Date(a.paidAt))
                  .map((item, index) => {
                    return (
                      <li
                        key={index}
                        className=""
                        onClick={() => toggleContentVisibility(index, item)}
                      >
                        <div className="borderTickets">
                          <div className="ticketsHeader">
                            <div className="logoDateName">
                              <div className="logoStore">
                                <img
                                  src={item?.storeInfo?.logo}
                                  alt="logo"
                                  className="logoPhoto"
                                />
                              </div>
                              <div className="nameTime">
                                <span className="storeName">
                                  {item?.storeInfo?.name}
                                </span>
                                <div>
                                  <p className="dateTime">
                                    {new Date(item?.paidAt).toLocaleString('fr-FR', {
                                      timeZone: 'Europe/Paris',
                                      year: 'numeric',
                                      month: '2-digit',
                                      day: '2-digit',
                                      hour: '2-digit',
                                      minute: '2-digit',
                                    }).replace(' à', '')}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="priceTicketScreen">
                              {formatPriceWithEuro(item.itemsPrice)}
                            </div>
                          </div>
                          <div
                            className={`ticketFooter ${
                              visibleTickets[index] || index === 0
                                ? 'ticketFooterFirst'
                                : ''
                            }`}
                          >
                            <div className="detailsTicketScreen">
                              <div className="productsTicketScreen">
                                <div
                                  className="clickProducts"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleContentProductVisibility(index);
                                  }}
                                >
                                  {ticketLength(item.orderItems) > 1 ? (
                                    <p className="numberProducts">
                                      {ticketLength(item.orderItems)} produits
                                    </p>
                                  ) : (
                                    <p className="numberProducts">
                                      {ticketLength(item.orderItems)} produit
                                    </p>
                                  )}
                                  <img
                                    className="arrowTicketScreen"
                                    src="/images/previous.png"
                                    alt="arrowTicketScreen"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleContentProductVisibility(index);
                                    }}
                                  />
                                </div>

                                <div
                                  className={`separator ${
                                    visibleProducts[index]
                                      ? 'underSeparator'
                                      : ''
                                  }`}
                                >
                                  <div className="productsName">
                                    {item.orderItems.map((item_, index_) => {
                                      return (
                                        <li
                                          key={index_}
                                          className="ProductsNamePicturePrice"
                                        >
                                          <div className="productsTitle">
                                            <div>
                                              <img
                                                src={item_.image}
                                                className="productsPicture"
                                                alt=""
                                              />
                                            </div>
                                            <div>{item_.name}</div>
                                          </div>

                                          <div>
                                            {formatPriceWithEuro(item_.price)} x{' '}
                                            {item_.Qty}
                                          </div>
                                        </li>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="refFooter">
                              <div className="detailRef">
                                <span className="methodOrder">Order ID</span>
                                <span className="idTicketScreen">
                                  {item._id}
                                </span>
                              </div>
                              {item?.externalInvoiceId && (
                                <div className="detailRef">
                                  <span className="methodOrder">
                                    N° Facture
                                  </span>
                                  <span className="idTicketScreen">
                                    {item.externalInvoiceId}
                                  </span>
                                </div>
                              )}
                              <div className="detailRef">
                                <span className="methodOrder">
                                  Méthode de paiement
                                </span>
                                {item.paymentMethod && (
                                  <span className="idTicketScreen">
                                    {item.paymentMethod.toUpperCase()}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
            </>
          )}

          {/* <FooterNavbar props={{ account: true }} /> */}
        </div>
      )}
    </>
  );
};

export default TicketScreen;
